interface ErrorResponse {
    code: number;
    message: string;
}

export interface SmartbetTrackingState {
    smartbetTrackingeData: any;
    loading: boolean;
    smartbetTrackingeError: ErrorResponse | null;
}


export enum SmartbetTrackingActionTypes {
    FETCH_SMARTBET_TRACKING_DATA = "FETCH_SMARTBET_TRACKING_DATA",
    FETCH_SMARTBET_TRACKING_DATA_SUCCESS = "FETCH_SMARTBET_TRACKING_DATA_SUCCESS",
    FETCH_SMARTBET_TRACKING_DATA_ERROR = "FETCH_SMARTBET_TRACKING_DATA_ERROR",
}

export type SmartbetTrackingAction =
    | { type: SmartbetTrackingActionTypes.FETCH_SMARTBET_TRACKING_DATA }
    | { type: SmartbetTrackingActionTypes.FETCH_SMARTBET_TRACKING_DATA_SUCCESS; payload: any[] }
    | { type: SmartbetTrackingActionTypes.FETCH_SMARTBET_TRACKING_DATA_ERROR; payload: any };